<template>
    <div class="brand-book-fashion-hero pos-absolute pos-top pos-left w-full h-full">
        <BrandBookSectionHeroImage src="ESTILO-FOTOGRÁFICO1.png" />
        <BrandBookSectionHeroImage src="ESTILO-FOTOGRÁFICO2.png" />
        <BrandBookSectionHeroImage src="ESTILO-FOTOGRÁFICO3.png" />
        <BrandBookSectionHeroImage src="ESTILO-FOTOGRÁFICO4.png" />
    </div>
</template>

<script>
    import BrandBookSectionHeroImage from './BrandBookSectionHeroImage';

    export default {
        name: 'BrandBookFashionHero',
        components: { BrandBookSectionHeroImage },
    };
</script>
